import Drawer from 'react-modern-drawer';
import React, { useEffect, useState } from "react";
import ReportsServices from './ReportsServices';
import { CommonUtilities } from 'commonUtils';
import DeleteDialogueBox from 'components/Common/deleteDialogue';
import Pagination from 'components/Common/newPagination';

export default function AddReporting_Transaction(param: any) {


    const [transactionsToDisplay, setTransactionsToDisplay] = useState<any>([]);
    const closeAddReportTransaction = () => { param.closeAddReportTransaction() }
    let Data = { pageNumber: 1, pageSize: 10, processReferenceId: '', manualReference: "", isActive: 1 };

    const getAddedTransactions = () => {

        console.log(param?.ExistingReferences?.filter((val: any) => val.processReferenceId == param?.selectedReference)[0])
        Data.manualReference = param?.ExistingReferences?.filter((val: any) => val.processReferenceId == param?.selectedReference)[0]?.manualReference;
        Data.processReferenceId = param?.selectedReference

        console.log(Data)
        ReportsServices.AddedTransactions(Data).then((res) => {
            setTransactionsToDisplay(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
            totalRow = res?.totalRows
            settotalRow(totalRow)
        });
    }

    useEffect(() => {
        getAddedTransactions()
    }, [param.ReportingTransactionOpen]);


    let [totalRow, settotalRow] = useState(0);
    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        getAddedTransactions();
    }

    const addReferenceForInvoices = (invoice: any) => {
        console.log(invoice)
        console.log(param?.data)

        var pay_Load = {
            isActive: 1,
            manualReference: param?.data?.manualReference,
            processReferenceId: param?.data?.processReferenceId,
            referenceCode: invoice?.invoicenum,
            weekNumber: param?.data?.weekNumber,
            yearNumber: param?.data?.yearNumber
        }

        ReportsServices.processReferenceSave(pay_Load).then((res: any) => {
            getAddedTransactions()
        })

    }

    return (
        <Drawer open={param.AddReportTransaction} onClose={closeAddReportTransaction} direction='right' >

            <div className="box noBorderRadius noBorder full-height-vh  pull-left ws-7">

                <div className="box-header-main">
                    <h2>Transaction To Add</h2>
                </div>

                <div className="box-content pull-right">

                    <div className="form-format ws-12 mb">
                        <div className="label-entries ws-12">
                            <input type="text" placeholder="Filter" />
                        </div>
                    </div>

                    <div className="ws-12 ">
                        <table className="newTable">
                            <thead>
                                <th></th>
                                <th>Invoice Num</th>
                                <th>Header Type</th>
                                <th>Transaction ref</th>
                                <th>Home Value</th>
                                <th>Status</th>
                                <th>Manual Reference</th>
                                <th>Extended Status</th>
                                <th>Invoice Date</th>
                            </thead>

                            {
                                transactionsToDisplay.map((post: any, index: any) => {
                                    return (
                                        <tbody>

                                            <tr>
                                                <td  ><input type="checkbox" name="checkbox2" onClick={() => addReferenceForInvoices(post)} /></td>
                                                <td>{post.invoicenum}</td>
                                                <td>{post.headertype}</td>
                                                <td>{post.transactionref}</td>
                                                <td>{post.homevalue}</td>
                                                <td>{post.status}</td>
                                                <td>{post.manualReference}</td>
                                                <td>{post.extendedStatus}</td>
                                                <td>{post.invoiceDate}</td>
                                            </tr>

                                        </tbody>

                                    )
                                })}

                        </table>

                    </div>

                    <div className="ws-12">
                        {
                            (() => {
                                if (totalRow && totalRow > 10) {
                                    return <div className="box-footer ws-12"> <Pagination onPageChange={handleNameOnChange} totalRow={totalRow} /> </div>
                                }

                            })()
                        }
                        <button className="icon-btn delete width100 height40 pull-right" onClick={closeAddReportTransaction}> Close </button>
                    </div>

                </div>

            </div>

        </Drawer>
    )
}